import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportCostSettlement, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const EXP001 = ({ configProcedure }: Props) => {

    const Exportations = useDataBean(_Exportations);
    const [finalizar, setFinalizar] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", configProcedure?._procedure.IDProcedureImp);

        if (props.IDExportation) {
            Exportations.instance.getExportationsCatalogPorPropiedades({ IDExportation: props.IDExportation }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        console.log(configProcedure?._procedure)
                        Exportations.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
        else {
            Exportations.setBean({
                IDProcedureImp: configProcedure?._procedure.IDProcedureImp,
                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID()
            });
        }
    }, [props])
    useEffect(() => {
        getLista()
    }, [])
    const getLista = () => {

        Exportations.instance.getExportationsCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(Exportations.bean.Observations)
        }

        if (configProcedure?._pushProps) {
            let x = {
                Item: Exportations.bean.Item,
                ExportRequest: Exportations.bean.ExportRequest,
                FlightNumber: Exportations.bean.FlightNumber,
                Declaration: Exportations.bean.Declaration,
                PNC: Exportations.bean.PNC,
                SAENumber: Exportations.bean.SAENumber,
                SAEDate: Exportations.bean.SAEDate,
                QuantityUnits: Exportations.bean.QuantityUnits,
                QuantityPackages: Exportations.bean.QuantityPackages,
                GrossWeight: Exportations.bean.GrossWeight,
                FOBValue: Exportations.bean.FOBValue,
                NumberTransferSheet: Exportations.bean.NumberTransferSheet,
                TransferSheetDate: Exportations.bean.TransferSheetDate,
                AerialOperationNumber: Exportations.bean.AerialOperationNumber,
                AerialOperationDate: Exportations.bean.AerialOperationDate,
                ExportDeclarationNumber: Exportations.bean.ExportDeclarationNumber,
                ExportDeclarationDate: Exportations.bean.ExportDeclarationDate,
                Client: Exportations.bean.Client,
                Observations: Exportations.bean.Observations,
                ExchangeRate: Exportations.bean.ExchangeRate,
                Value: Exportations.bean.Value,
                ItemType: Exportations.bean.ItemType,
                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID()

            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(Exportations.bean)
        }
        toast.success('Actualizado')
    }
    const head = [
        { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        { title: 'Número consecutivo de registro', property: 'Item', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Número de vuelo', property: 'FlightNumber', visible: true },
        { title: 'Declaración', property: 'Declaration', visible: true },
        { title: 'Numero de matricula de la aeronave PNC', property: 'PNC', visible: true },
        { title: 'Numero de Solicitud de Autorización de Embarque SAE', property: 'SAENumber', visible: true },
        { title: 'Fecha de registro de la solicitud SAE', property: 'SAEDate', visible: true },
        { title: 'Cantidad Unidades', property: 'QuantityUnits', visible: true },
        { title: 'Cantidad de paquetes', property: 'QuantityPackages', visible: true },
        { title: 'Peso bruto', property: 'GrossWeight', visible: true },
        { title: 'FOB Valor', property: 'FOBValue', visible: true },
        { title: 'Numero de Hoja de transferencia', property: 'NumberTransferSheet', visible: true },
        { title: 'Número de operación aérea', property: 'AerialOperationNumber', visible: true },
        { title: 'Número de declaración de exportación', property: 'ExportDeclarationNumber', visible: true },
        { title: 'Exportacaciones Elaborado por', property: 'MadeBy', visible: true },
        { title: 'Revisado por', property: 'ReviewedBy', visible: true },
        { title: 'ID procesos', property: 'IDProcedureImp', visible: true },

    ]

    const create = () => {
        Exportations.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        Exportations.update().then(
            (resp: any) => {
                // onExportMap()
                console.log(resp)
                getLista()
                Exportations.setBean(resp);
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const editaitemfinalizar = () => {
        //console.log(entailment.bean);
        Exportations.update().then(
            (resp: any) => {
                onExportMap()
                console.log(resp)

                Exportations.setBean(resp);
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12">
                        <label>Tipo de  Item / Lote</label>
                        <SelectTHConstantsValue code={602} value={Exportations.bean?.ItemType} onChange={(e: any) => { Exportations.setBean({ ...Exportations.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                    </div>
                    <div className="col-md-6">
                        <label>Número consecutivo de registro</label>
                        <input type="text" name="Item" className="form-control" value={Exportations.bean?.Item || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Solicitud de Exportación</label>
                        <input type="text" name="ExportRequest" className="form-control" value={Exportations.bean?.ExportRequest || ""} onChange={Exportations.handleChange} />
                    </div>

                    <div className="col-md-6">
                        <label>Número de vuelo</label>
                        <input type="text" name="FlightNumber" className="form-control" value={Exportations.bean?.FlightNumber || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Declaración</label>
                        <input type="text" name="Declaration" className="form-control" value={Exportations.bean?.Declaration || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Numero de matricula de la aeronave PNC</label>
                        <input type="text" name="PNC" className="form-control" value={Exportations.bean?.PNC || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Numero de Solicitud de Autorización de Embarque SAE</label>
                        <input type="text" name="SAENumber" className="form-control" value={Exportations.bean?.SAENumber || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="SAEDate" label="Fecha de registro de la solicitud de autorización de embarque" value={Exportations.bean?.SAEDate || ""} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "SAEDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Cantidad Unidades</label>
                        <input type="text" name="QuantityUnits" className="form-control" value={Exportations.bean?.QuantityUnits || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Cantidad de paquetes</label>
                        <input type="text" name="QuantityPackages" className="form-control" value={Exportations.bean?.QuantityPackages || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Peso bruto</label>
                        <input type="text" name="GrossWeight" className="form-control" value={Exportations.bean?.GrossWeight || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>FOB Valor</label>
                        <input type="text" name="FOBValue" className="form-control" value={Exportations.bean?.FOBValue || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Numero de Hoja de transferencia</label>
                        <input type="text" name="NumberTransferSheet" className="form-control" value={Exportations.bean?.NumberTransferSheet || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">

                        <InputDate name="TransferSheetDate" label="Fecha de la hoja de transferencia" value={Exportations.bean?.TransferSheetDate || ""} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "TransferSheetDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de operación aérea</label>
                        <input type="text" name="AerialOperationNumber" className="form-control" value={Exportations.bean?.AerialOperationNumber || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">

                        <InputDate name="AerialOperationDate" label="Fecha de operación aérea" value={Exportations.bean?.AerialOperationDate || ""} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "AerialOperationDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de declaración de exportación</label>
                        <input type="text" name="ExportDeclarationNumber" className="form-control" value={Exportations.bean?.ExportDeclarationNumber || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">

                        <InputDate name="ExportDeclarationDate" label="Fecha de declaración de exportación" value={Exportations.bean?.ExportDeclarationDate || ""} setDate={(e: any) => { Exportations.setBean({ ...Exportations.bean, "ExportDeclarationDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Cliente</label>
                        <input type="text" name="Client" className="form-control" value={Exportations.bean?.Client || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Tipo de cambio</label>
                        <input type="text" name="ExchangeRate" className="form-control" value={Exportations.bean?.ExchangeRate || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor</label>
                        <input type="text" name="Value" className="form-control" value={Exportations.bean?.Value || ""} onChange={Exportations.handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="Observations" className="form-control" value={Exportations.bean?.Observations || ""} onChange={(e) => { Exportations.setBean({ ...Exportations.bean, 'Observations': e.target.value }) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={editaItem}>Guardar Datos*</BasicButton>
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch estado={finalizar} label="Finalizar Cargue de Información?" eventChange={(e: any) => { setFinalizar(e) }}></BasicSwitch>
                    </div>
                    {finalizar &&
                        <>
                            <div className="col-md-6 mt-4">
                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={editaitemfinalizar}>Finalizar*</BasicButton>
                            </div>
                        </>}
                </div>
                <div className="row">
                    <BasicTable body={lista} head={head} rowSet={Exportations.setBean}></BasicTable>
                </div>
            </div>
        </div>
    )
}